const AppRoute = {
  aboutDictionary: "/o-słowniku",
  dictionaryEntries: "/lista-haseł",
  home: "/",
  synonym: "/synonim",
  notFound: "/404",
} as const;

export default AppRoute;
